import { render, staticRenderFns } from "./AdminAllocation.vue?vue&type=template&id=0d789abd&"
import script from "./AdminAllocation.vue?vue&type=script&lang=js&"
export * from "./AdminAllocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\laragon\\www\\270b-ariq\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d789abd')) {
      api.createRecord('0d789abd', component.options)
    } else {
      api.reload('0d789abd', component.options)
    }
    module.hot.accept("./AdminAllocation.vue?vue&type=template&id=0d789abd&", function () {
      api.rerender('0d789abd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/allocation/AdminAllocation.vue"
export default component.exports